module.exports = __webpack_public_path__ + "static/media/favicon-michelin_com_512x512.f2a3243e.png";